import {Navigate, NavLink, useParams} from 'react-router-dom';
import useSWR from 'swr'

import arrow from "assets/images/svg/arrow-icon-lf.svg"
import bg from "assets/images/news-bg.png"
import newsBgM from "assets/images/news-bg-m.png";

import st from './NewsDetail.module.scss'
import {useAppContext} from 'Context'
import {Spinner} from 'components/Spinner/Spinner'
import {formatDate} from 'helpers'

const fetcher = (...args) => {
    return fetch(args, {
        headers: {
            'Access-Control-Allow-Origin': 'https://er.ru'
        }
    }).then(res => res.json())
}


export const NewsDetail = ()=> {
    const { id } = useParams()
    const { prevPath } = useAppContext()
    const { data, isLoading } = useSWR(`${process.env.REACT_APP_NEWS_API}/news_list?per_page=1&id=${id}`, fetcher)
    const cnLoader = st.content_wrap+' '+(isLoading ? st.content_load : '')
    const black = prevPath?.includes('/news/') ? '/news' : prevPath

    if (!isLoading && !data) return <Navigate to='/news' />

    return (
        <section className={st.news_detail}>
            <div className={st.bg}>
                <picture>
                    <source media='(max-width: 400px)' srcSet={newsBgM} />
                    <img src={bg} alt="" width={100} height={100} />
                </picture>
            </div>
            <div className="wrapper">
                <div className={st.head}>
                    <NavLink to={black} className={st.link} >
                        <img src={arrow} alt="" width={24} height={24} />
                        <span>Назад</span>
                    </NavLink>
                </div>

                <div className={st.content}>
                    {isLoading && <div className={st.loader}><Spinner /></div>}

                    {data &&
                        <div className={cnLoader}>
                            <h1 className={st.title}>{data?.data[0]?.title}</h1>
                            <p className={st.date}>{formatDate(data?.data[0]?.date_updated)}</p>
                            <div className={st.image}>
                                <picture>
                                    <img src={data?.data[0]?.url_image} alt=""/>
                                </picture>
                                <span>Источник фото: ER.RU</span>
                            </div>

                            <div className={st.inject}>
                                <h2>{data?.data[0]?.announce}</h2>
                                <p dangerouslySetInnerHTML={{__html: data?.data[0]?.body}} />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
}
